<template>
  <div>
    <PageHead title="短信列表"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">业务名称：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入业务名称"
                v-model="queryForm.titleName"
              />
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="mb20 search-btns mt20">
        <a-button type="primary" @click="addshort" icon="plus">
          新增短信</a-button
        >
      </div>

      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>

        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record, 1)">
            查看
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="downloadResult(record.id)"
          >
            下载发送结果
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <!-- 新增弹窗 -->
    <a-modal
      v-model="visible"
      :title="addLookTitle"
      @ok="handleOk"
      @afterClose="afterClose"
      @cancel="onCancelModel"
      :width="800"
    >
      <div class="role-formCont">
        <span class="w100 rightAlgin">业务名称:</span>
        <a-input
          :disabled="isLookDetail"
          class="w300 ml20"
          placeholder="请输入业务名称"
          v-model="addForm.titleName"
        />
      </div>
      <blank height="20"> </blank>
      <div class="role-formCont">
        <span class="w100 rightAlgin">下发人群:</span>
        <a-select
          :disabled="isLookDetail"
          v-model="addForm.smsGroupId"
          mode="multiple"
          class="w300 ml20"
          placeholder="请输入下发人群"
          @change="aaaa"
        >
          <a-select-option
            v-for="(shortItem, index) in shortvalue"
            :value="shortItem.id"
            :key="index"
          >
            {{ shortItem.groupName }}
          </a-select-option>
        </a-select>
      </div>
      <blank height="20"> </blank>
      <div class="role-formCont">
        <span class="w100 rightAlgin">短信内容:</span>
        <a-textarea
          :disabled="isLookDetail"
          class="w300 ml20"
          placeholder="请输入短信内容"
          v-model="addForm.text"
          :rows="2"
        />
      </div>
    </a-modal>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 80
  },

  {
    title: '创建人',
    dataIndex: 'userName',
    key: 'userName',
    ellipsis: true
  },

  {
    title: '创建时间',
    dataIndex: 'creationTime',
    key: 'creationTime',
    ellipsis: true
  },
  {
    title: '业务名称',
    dataIndex: 'titleName',
    key: 'titleName',
    scopedSlots: { customRender: 'titleName' },
    ellipsis: true
  },
  {
    title: '下发人群',
    dataIndex: 'smsGroupName',
    key: 'smsGroupName',
    scopedSlots: { customRender: 'smsGroupName' },
    ellipsis: true
  },
  {
    title: '下发数量',
    dataIndex: 'issuedCount',
    key: 'issuedCount',
    scopedSlots: { customRender: 'issuedCount' },
    ellipsis: true
  },
  {
    title: '失败数量',
    dataIndex: 'failCount',
    key: 'failCount',
    scopedSlots: { customRender: 'failCount' },
    ellipsis: true
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 260
  }
]

import {
  smsNoticeList,
  smsNoticeSave,
  getSMSGroupList,
  smsNoticeExport
} from './api/api'
export default {
  data() {
    return {
      timeHorizon: [], //时间范围
      queryForm: {},
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false,
      addForm: {},
      visible: false,
      shortvalue: [],
      addLookTitle: '', // 弹窗标题 新增 查看区别
      isLookDetail: false // 查看标识
    }
  },
  created() {
    this.load()
  },
  methods: {
    aaaa(a, b, c) {},
    // 短信组
    getSMSGroupListFn() {
      let params = {}
      params.page = 1
      params.size = 1000
      getSMSGroupList(params).then((res) => {
        // this.loading = false
        if (res.data.code == 0) {
          this.shortvalue = res.data.data
        }
      })
    },
    // 查看 新增弹窗确认回调
    handleOk() {
      if (this.isLookDetail) {
        this.visible = false
      } else {
        let params = {}
        params.smsGroupId = this.addForm.smsGroupId.join('/')
        params.text = this.addForm.text
        params.titleName = this.addForm.titleName
        smsNoticeSave(params).then((res) => {
          if (res.data.code === 0) {
            this.visible = false
            this.load()
            this.addForm = {}
          }
        })
      }
    },
    // 弹窗
    addshort() {
      this.visible = true
      this.isLookDetail = false
      this.addLookTitle = '新增短信'
      // 弹窗获取 短信组列表
      this.getSMSGroupListFn()
    },
    // 查看名称
    lookConT(list) {
      if (list.length > 0) {
        let title = ''
        list.forEach((item, index) => {
          title = index > 0 ? title + '、' + item : title + item
        })
        this.$warning({
          // width: "600px",
          title: title
        })
      }
    },
    // 拉取列表
    load() {
      this.loading = true
      let params = {}
      params.titleName = this.queryForm.titleName
      params.page = this.page
      params.size = this.size
      smsNoticeList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    // 删除 暂无
    // showDeleteConfirm(id) {
    //   this.$confirm({
    //     title: '确定删除吗?',
    //     okType: 'danger',
    //     onOk: () => {
    //       mfNoticeDelete({ id }).then((res) => {
    //         if (res.data.code == 0) {
    //           this.$message.success('删除成功')
    //           this.page = 1
    //           this.load()
    //         }
    //       })
    //     }
    //   })
    // },
    // 撤回 暂无
    // withdrawParty(id) {
    //   this.$confirm({
    //     title: '确定撤回吗?',
    //     okType: 'danger',
    //     onOk: () => {
    //       mfNoticeWithdrawParty({ id }).then((res) => {
    //         if (res.data.code == 0) {
    //           this.$message.success('撤回成功')
    //           this.page = 1
    //           this.load()
    //         }
    //       })
    //     }
    //   })
    // },
    goDetial(data, index) {
      this.isLookDetail = true // 查看弹窗
      this.addForm = data //
      this.addForm.smsGroupId = data.smsGroupName
      this.visible = true
      this.addLookTitle = '查看短信'
    },
    // 分页
    pageChange(pageber) {
      this.page = pageber
      this.load()
    },
    // 取消
    cancel() {
      this.queryForm = {}
      this.timeHorizon = []
    },
    // 查询
    subMit() {
      this.page = 1
      this.load()
    },
    // 关闭弹窗回调 清空参数 标识
    afterClose() {
      this.addForm = {}
      this.isLookDetail = false
    },
    // 取消弹窗 关闭弹窗回调 清空参数 标识
    onCancelModel() {
      this.addForm = {}
      this.isLookDetail = false
    },
    //下载模板
    downloadResult(id) {
      let params = {
        id: id
      }
      //下载模板 smsNoticeExport
      smsNoticeExport(params).then((response) => {
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = '发送结果.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 180px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // flex-wrap: wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 5px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/shortMessage/index.vue